import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/** Orders table columns the merchant turned off. Empty = every column shown (the default). */
interface OrderColumnsState {
  hidden: string[];
}

interface OrderColumnsActions {
  toggle: (key: string) => void;
  showAll: () => void;
}

type OrderColumnsStore = OrderColumnsState & OrderColumnsActions;

/** Kept in this browser only: a viewing preference, not account data. */
const useOrderColumnsStore = create<OrderColumnsStore>()(
  persist(
    (set) => ({
      hidden: [],
      toggle: (key) =>
        set((s) => ({
          hidden: s.hidden.includes(key) ? s.hidden.filter((k) => k !== key) : [...s.hidden, key],
        })),
      showAll: () => set({ hidden: [] }),
    }),
    {
      name: 'orders-hidden-columns',
      storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
    },
  ),
);

export const selectHiddenColumns = (s: OrderColumnsStore) => s.hidden;
export const selectToggleColumn = (s: OrderColumnsStore) => s.toggle;
export const selectShowAllColumns = (s: OrderColumnsStore) => s.showAll;

export default useOrderColumnsStore;
